/* eslint-disable import/no-cycle */
import { postDataUtils } from '../index-utils';

// Example POST method implementation:
export function postData(url = '', data = {}) {
  return postDataUtils(url, data);
}
